/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Stat_RebookInputs */

const en_hero_stat_rebook = /** @type {(inputs: Hero_Stat_RebookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients who rebook`)
};

const pl_hero_stat_rebook = /** @type {(inputs: Hero_Stat_RebookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienci, którzy wracają`)
};

/**
* | output |
* | --- |
* | "Clients who rebook" |
*
* @param {Hero_Stat_RebookInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_stat_rebook = /** @type {((inputs?: Hero_Stat_RebookInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Stat_RebookInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_stat_rebook(inputs)
	return en_hero_stat_rebook(inputs)
});